import { findClientPocketBalance } from '../../_services/pocket_balance.service';
import { 
    findClientsWithPocketBalanceByCompany, 
    findClientsWithPocketBalanceBySellerCompany,
    findClientsWithPaymentsBySellerCompany,
    findClientsWithDeparturesBySellerCompany,
    findClientsWithOrdersListBySellerCompany
} from '../../_services/client.service';

export const findClientPocketBalanceEvent = async (client_cod) => {
    let res = await findClientPocketBalance(client_cod);
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllPocketBalanceEvent = async () => {
    let res = await findClientsWithPocketBalanceByCompany();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllPocketBalanceBySellerEvent = async () => {
    let res = await findClientsWithPocketBalanceBySellerCompany();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllPaymentsBySellerEvent = async () => {
    let res = await findClientsWithPaymentsBySellerCompany();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllDeparturesBySellerEvent = async () => {
    let res = await findClientsWithDeparturesBySellerCompany();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}

export const findAllOrdersListBySellerEvent = async () => {
    let res = await findClientsWithOrdersListBySellerCompany();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}